import { useMemo } from 'react';
import {
  RouteResponse,
  isRouteResult,
} from '../../dayplanning/dayplanning.types';

export interface RouteTotals {
  distanceKm: number;
  durationMinutes: number;
  distanceStr: string;
  durationStr: string;
}

/**
 * Calculate total distance and duration from routes
 * Formats values into human-readable strings
 */
export function useRouteTotals(
  routes: RouteResponse[] | undefined,
): RouteTotals | null {
  return useMemo(() => {
    if (!routes || routes.length === 0) return null;

    let totalKm = 0;
    let totalMinutes = 0;

    for (const route of routes) {
      if (isRouteResult(route)) {
        totalKm += route.distance_km || 0;
        totalMinutes += route.duration_minutes || 0;
      }
    }

    // Format duration as hours and minutes
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.round(totalMinutes % 60);
    const durationStr =
      hours > 0 ? `${hours}h ${minutes}m` : `${Math.round(totalMinutes)}m`;

    return {
      distanceKm: totalKm,
      durationMinutes: totalMinutes,
      distanceStr: `${totalKm.toFixed(1)} km`,
      durationStr,
    };
  }, [routes]);
}
